import { Annotation } from '../../../types/annotation';
import { TimelineAnnotation } from './TimelineAnnotation';


interface TimelineAnnotationsProps {
  annotations: Annotation[];
  duration: number;
  streamStart: Date;
  onAnnotationClick: (id: string) => void;
}

export function TimelineAnnotations({ 
  annotations, 
  duration,
  streamStart,
  onAnnotationClick 
}: TimelineAnnotationsProps) {
  return (
    <>
      {annotations.map((annotation) => (
        <TimelineAnnotation
          key={annotation.id}
          id={annotation.id}
          startTime={(annotation.startTime.getTime() - streamStart.getTime()) / 1000}
          endTime={(annotation.endTime.getTime() - streamStart.getTime()) / 1000}
          duration={duration}
          color={annotation.color}
          text={annotation.text}
          onClick={onAnnotationClick}
        />
      ))}
    </>
  );
}